import KPITrend from './KPITrend';

export default (props) => {
  return <KPITrend {...props} />;
};
